import { render, staticRenderFns } from "./seriesList.vue?vue&type=template&id=0d988128&scoped=true"
import script from "./seriesList.vue?vue&type=script&lang=js"
export * from "./seriesList.vue?vue&type=script&lang=js"
import style0 from "./seriesList.vue?vue&type=style&index=0&id=0d988128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d988128",
  null
  
)

export default component.exports